import DialogBase from "../libs/DialogBase";
import Splide from '@splidejs/splide';
import Util from "../libs/Util";
import gsap from "../libs/gsap.min";
import Api from "../libs/Api";
import dayjs from "dayjs";

export default class DialogCalendar extends DialogBase {
  static EVENT_UPDATE_SELECT_DISPLAY = "eventUpdateSelectDisplay";

  constructor(_searchParentEl,_masterData,_defaultDays) {
    super("#dialog_calendar");

    this.CL_OPEN = 'isOpen';
    this.CL_DISABLED = 'isDisabled';

    this.TYPE_START = 'start';
    this.TYPE_END = 'end';
    this.TYPE_MIDDLE = 'middle';

    this.isCalReady = false;

    const urlParams = new URLSearchParams(window.location.search);
    const checkindate = urlParams.get('checkindate');
    const checkoutdate = urlParams.get('checkoutdate');
    if(checkindate && checkoutdate){
      _defaultDays = {go:Util.formatStringToDate(checkindate),back:Util.formatStringToDate(checkoutdate)};
    }

    this.bg = this.target.querySelector('.gl_common_dialog__bg');
    this.window = this.target.querySelector('.gl_common_dialog__window');

    this.splideEl = this.target.querySelector('.splide');

    this.btnTarget = _searchParentEl.querySelector('.js-dialog_calendar');
    this.btnTarget.addEventListener('click',this.onClickOpen.bind(this));

    this.selectDisplay = this.target.querySelector('.-js-select_display');

    this.btnSubmit = this.target.querySelector('.-btn_submit button');

    window.addEventListener('resize',this.onResize.bind(this));

    this.buttonsList = null;
    this.startEl = null;
    this.endEl = null;

    this.startDays = null;
    this.endDays = null;

    // URLにチェックイン日とチェックアウト日がない場合、画面のチェックイン日とチェックアウト日のデフォルト値を設定
    if (!_defaultDays) {
      const dategoing = window.DEFAULT_DATA.checkInDate;
      const dateback = window.DEFAULT_DATA.checkOutDate;
      _defaultDays = {go:Util.formatStringToDate(dategoing),back:Util.formatStringToDate(dateback)};
    }

    this.onInit(_masterData,_defaultDays);
  }

  onInit(data,_defaultDays){
    //const data = await Api.getMasterTicketData();
    const calStartAndEnd = this.getCalenderData(data);
    const masterCal = {};
    data.calender.forEach(c=>{
      masterCal[c.settingdate] = c;
    });
    const calStart = new Date(calStartAndEnd.calender_start);
    const calEnd = new Date(calStartAndEnd.calender_end);
    const calStartTime = calStart.getTime();

    // デフォルト値がカレンダーよりも前だった場合の調整は不要（範囲内になるため）
    this.startDays = Util.formatDate(_defaultDays.go);
    this.endDays = Util.formatDate(_defaultDays.back);

    calStart.setDate(1);
    let diffMonth = (calEnd.getFullYear() - calStart.getFullYear()) * 12;
    diffMonth -= calStart.getMonth() + 1;
    diffMonth += calEnd.getMonth() + 2;

    const weekStr = ['日','月','火','水','木','金','土'];
    const cal = [];
    for(let i = 0; i < diffMonth; i++){
      const re = {ttl:'',days:[]};
      const date = new Date(calStart.getFullYear(),calStart.getMonth() + i,calStart.getDate());
      const firstWeek = date.getDay();
      date.setMonth(date.getMonth() + 1,0);
      const month = date.getMonth() + 1;

      re.ttl = `${date.getFullYear()}年${month}月`;

      for(let a=0;a < firstWeek;a++) re.days.push({type:'space'});

      for(let a=1;a<=date.getDate();a++){
        const d = new Date(date.getFullYear(),date.getMonth(),a,9);
        const cd = masterCal[d.getFullYear()+"-"+String(d.getMonth() + 1).padStart(2,"0")+"-"+(String(d.getDate()).padStart(2,"0"))];

        let type = (d.getTime() < calStartTime)?'past':'active';

        // 1年後以降の日付を非アクティブ化
        if (calEnd.getTime() < d.getTime()) {
          type = 'past';
        }

        re.days.push({
          type,
          holiday:cd?.holidayflag,
          d:Util.formatDate(d),
          txt:a
        });
      }

      cal.push(re);
    }

    let calHtml = '';

    cal.forEach((item,i)=>{
      calHtml += `
  <div class="splide__slide">

  <div class="-cal">
    <div class="-cal_head">${item.ttl}</div>
    <div class="-cal_body">
      <div class="-week">${weekStr.map(v=>`<div>${v}</div>`).join("")}</div>
      <div class="-days">`;
      item.days.forEach((day)=>{
        if(day.type === 'space') calHtml += `<div class="-space"></div>`;
        if(day.type === 'past') calHtml += `<div class="-past" data-holiday="${day.holiday}">${day.txt}</div>`;
        if(day.type === 'active') {
          calHtml += `
          <button type="button"
                    data-d="${day.d}"
                    data-type=""
                    data-holiday="${day.holiday}"
            ><span>${day.txt}</span></button>
          `;
        }
      });

     calHtml += `</div>
    </div>
  </div>

  </div>
   `;
    });

    this.target.querySelector('.-js-calendar').innerHTML = calHtml;
    this.isCalReady = true;

    this.buttonsList = [...this.splideEl.querySelectorAll('.-cal .-cal_body .-days button')];

    this.target.querySelectorAll('.-js-calendar button').forEach(el=>{
      el.addEventListener('click',(e)=>{
        const btn = e.currentTarget;
        this.onClickDay(btn.dataset.d,e.currentTarget);
      });
      el.addEventListener('mouseenter',this.onRollOverDay.bind(this));
      el.addEventListener('mouseleave',this.onRollOutDay.bind(this));
    });

    this.onMediaQueryOnChange({matches:this.isSp});

    this.onResetCal();
  }

  onClickDay(d,el){
    let tmpStartEl = this.startEl;
    let tmpEndEl = this.endEl;

    if(this.endDays !== null){
      tmpStartEl = null;
      tmpEndEl = null;
      this.startDays = null;
      this.endDays = null;
      this.startEl.dataset.type = "";
      this.endEl.dataset.type = "";
      this.startEl = null;
      this.endEl = null;
      this.resetTypeMiddle();
    }

    if(this.startDays === null){
      this.startDays = d;
      this.startEl = el;
    } else if(this.endDays === null){
      const start = new Date(this.startDays);
      const end = new Date(d);
      if(start.getTime() === end.getTime()) return;
      this.endDays = d;
      this.endEl = el;

      if(start.getTime() > end.getTime()){
        const sd = this.startDays;
        this.startDays = this.endDays;
        this.endDays = sd;
        this.startEl = el;
        this.endEl = tmpStartEl;
      }
    }

    if(tmpStartEl !== this.startEl){
      if(tmpStartEl) tmpStartEl.dataset.type = "";
      if(this.startEl) this.startEl.dataset.type = this.TYPE_START;
    }
    if(tmpEndEl !== this.endEl){
      if(tmpEndEl) tmpEndEl.dataset.type = "";
      if(this.endEl) this.endEl.dataset.type = this.TYPE_END;
    }

    this.updateSelectDisplay();
  }

  onRollOverDay(e){
    if(this.startDays === null || this.endDays !== null) return;
    this.fillMiddle(this.startEl,e.currentTarget);
  }
  onRollOutDay(e){
    if(this.endDays !== null) return;
    this.resetTypeMiddle();
  }

  fillMiddle(_el1,_el2){
    this.resetTypeMiddle();
    const p1 = this.buttonsList.indexOf(_el1);
    const p2 = this.buttonsList.indexOf(_el2);
    const start = Math.min(p1,p2) + 1;
    const end = Math.max(p1,p2);

    this.buttonsList.slice(start,end).map(el=>el.dataset.type = this.TYPE_MIDDLE);
  }
  resetTypeMiddle(){
    this.buttonsList.filter(el=>{
      if(el.dataset.type === this.TYPE_MIDDLE) el.dataset.type = "";
    });
  }

  onClickClose(e){
    if(!this.startDays || !this.endDays){
      //どちらか空の場合は元に戻す
      this.startDays = this.beforeDays.start;
      this.endDays = this.beforeDays.end;

      this.onResetCal();
    }

    this.onClose();
  }

  onResetCal(){
    this.buttonsList.filter(el=>{
      if(el.dataset.type === this.TYPE_MIDDLE) el.dataset.type = "";
      if(el.dataset.type === this.TYPE_START) el.dataset.type = "";
      if(el.dataset.type === this.TYPE_END) el.dataset.type = "";
    });

    this.startEl = this.buttonsList.find(el=>el.dataset.d === this.startDays);
    this.endEl = this.buttonsList.find(el=>el.dataset.d === this.endDays);
    //console.log(this.startEl,this.endEl,this.startDays,this.endDays);
    this.startEl.dataset.type = this.TYPE_START;
    this.endEl.dataset.type = this.TYPE_END;
    this.fillMiddle(this.startEl,this.endEl);

    this.updateSelectDisplay();
  }

  onResize(){
    if(this.isOpen && !this.isSp) this.setDialogWindowPosition();
  }

  onMediaQueryOnChange(e){
    this.isSp = e.matches;
    if(!this.isCalReady) return;

    if(this.splide){
      this.splide.destroy(true);
      this.splide = null;
    }

    if(this.window) {
      this.window.style.opacity = "";
      this.window.style.transform = "";
      this.bg.style.opacity = "";
      this.bg.style.transform = "";
    }

    if(this.isSp){
      if(this.isOpen) {
        this.setOverflowChange(true);
      }
    } else {
      if(this.isOpen) {
        this.setOverflowChange(false);
      }


      if(!this.splide){
        this.splide = new Splide(this.splideEl,{
          perPage:3,
          perMove:1,
          gap:50,
          pagination: false,
          arrows: true,
          flickPower: 100,
        });

        this.splide.mount();
      }
    }

    this.setDialogWindowPosition();
  }

  setOverflowChange(_flag){
    if(_flag){
      let p = Util.getWindowScrollWidth();
      this.html.style.overflow = "hidden";
      this.body.style.overflow = "hidden";
      this.body.style.paddingRight = p+"px";
    } else {
      this.html.style.overflow = "";
      this.body.style.overflow = "";
      this.body.style.paddingRight = "";
    }
  }

  setDialogWindowPosition(){
    if(!this.window) return;

    if(this.isSp) {
      this.window.style.top = '';
    } else {
      const rect = this.btnTarget.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      this.window.style.top = top + 'px';
    }
  }

  updateSelectDisplay(){
    this.selectDisplay.querySelector('[data-type="in"] .-value').innerHTML = this.startDays || '';
    this.selectDisplay.querySelector('[data-type="out"] .-value').innerHTML = this.endDays || '';

    if(this.startDays && this.endDays){
      this.btnSubmit.classList.remove(this.CL_DISABLED);
    } else {
      this.btnSubmit.classList.add(this.CL_DISABLED);
    }

    this.el.dispatchEvent(new CustomEvent(DialogCalendar.EVENT_UPDATE_SELECT_DISPLAY));
  }

  onClickOpen(e){
    if(this.isOpen) return;

    this.setDialogWindowPosition();

    this.onOpen();
  }

  onOpen() {
    this.isOpen = true;

    this.beforeDays = {start:this.startDays,end:this.endDays};

    gsap.set([this.bg,this.window],{
      ...(this.isSp?{y:"100%"}:{opacity:0})
    });
    this.target.style.display = "block";
    this.onOpenBefore();

    gsap.killTweensOf([this.bg,this.window]);

    if(this.isSp){
      this.startEl.closest(".-cal").scrollIntoView();
    } else {
      const cal = [...this.splideEl.querySelectorAll('.-cal')];
      const startIndex = cal.indexOf(this.startEl.closest('.-cal'));
      this.splide.options = { speed: 0 };
      this.splide.go(startIndex);
      this.splide.options = { speed: 400 };
    }

    this.btnTarget.classList.add(this.CL_OPEN);

    gsap.to([this.bg,this.window],{
      duration:this.time,
      ...(this.isSp?{y:0}:{opacity:1}),
      ease:this.easing,onComplete:()=>{
        this.onOpenAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN));
      }
    });

    this.setOverflowChange(this.isSp);
  }

  onClose(){
    this.onCloseBefore();

    this.btnTarget.classList.remove(this.CL_OPEN);

    gsap.killTweensOf([this.bg,this.window]);
    gsap.to([this.bg,this.window],{
      duration:this.time,
      ...(this.isSp?{y:"100%"}:{opacity:0}),
      ease:this.easing,onComplete:()=>{
        this.target.style.display = "none";
        this.isOpen = false;

        this.setOverflowChange(false);

        this.onCloseAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_CLOSE));
      }
    });
  }

  onOpenBefore(){
    this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN_BEFORE));
  }
  onOpenAfter(){
  }

  onCloseBefore(){
  }
  onCloseAfter(){
  }

  getCalenderData(data){
    let result = null;
    if(data.calender){
      const date = new Date();
      date.setDate(date.getDate() + 1);
      const tomorrow = date.getFullYear() + (date.getMonth()+1).toString().padStart(2, '0') + date.getDate().toString().padStart(2, '0');
      
      let daylimitcounter = 0;
      let dategoing = 0;
      let dateback = 0;
      for(let d = 0; d < data.calender.length; d++) {
        const calender = data.calender[d];
        if(calender.settingdate.replace(/-/g,"") >= tomorrow) {
          if(calender.businessdayflag == 1) {
            daylimitcounter++;
          }
          dategoing++;
          dateback = dategoing + 1;
          if(daylimitcounter >= 2) {
            break;
          }
        }
      }
      const goDay = dayjs(data.calender_term.calender_start).add(dategoing, 'd').toDate();
      const backDay = dayjs(data.calender_term.calender_end).add(dateback, 'd').toDate();
      result = {calender_start: goDay, calender_end: backDay};
    } else {
      const goDay = dayjs(data.calender_term.calender_start).add(LtikeCommon.HOTEL.DEFAULT_DATE.going, 'd').toDate();
      const backDay = dayjs(data.calender_term.calender_end).add(LtikeCommon.HOTEL.DEFAULT_DATE.back, 'd').toDate();
      result = {calender_start: goDay, calender_end: backDay};
    }

    return result;
  }
}
